import Overview from '@/app/dashboard/overview'

export default Overview
